<template>
    <div class="proposal">
        <el-row type="flex" class="row-bg" justify="center">
            <el-col :span="24">
                <el-form
                    :model="ruleForm"
                    :rules="rules"
                    ref="ruleForm"
                    :inline="true"
                    label-width="100px"
                    class="demo-ruleForm"
                >
                    <el-col>
                        <el-form-item label="投诉类型" prop="complainType">
                            <el-radio-group v-model="ruleForm.complainType">
                                <el-radio label="1">时效延误</el-radio>
                                <el-radio label="2">服务态度差</el-radio>
                                <el-radio label="3">虚假签收</el-radio>
                                <el-radio label="4">乱收费</el-radio>
                                <el-radio label="5">拒绝上门/上楼</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col>
                        <el-form-item label="您是" prop="isShipper">
                            <el-radio-group v-model="ruleForm.isShipper">
                                <el-radio label="1">
                                    发货方&nbsp&nbsp&nbsp</el-radio
                                >
                                <el-radio label="2">收货方</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col>
                        <el-form-item label="运单号" prop="waybill">
                            <el-input
                                class="long"
                                placeholder="请输入12位运单号"
                                maxlength="12"
                                v-model="ruleForm.waybill"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col>
                        <el-form-item class="black" label="姓名" prop="name">
                            <el-input
                                class="code"
                                placeholder="请输入姓名"
                                maxlength="20"
                                v-model="ruleForm.name"
                            ></el-input>
                        </el-form-item>
                        <el-form-item class="black" label="手机号" prop="phone">
                            <el-input
                                class="tele"
                                placeholder="请输入手机号"
                                maxlength="11"
                                v-model="ruleForm.phone"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-form-item label="投诉内容" prop="content">
                        <el-input
                            class="long"
                            placeholder="请详细描述您的问题，便于我们更好的为您处理"
                            type="textarea"
                            maxlength="300"
                            v-model="ruleForm.content"
                        ></el-input>
                    </el-form-item>
                    <el-col>
                        <el-form-item label="验证码" prop="captcha">
                            <el-input
                                class="code"
                                maxlength="4"
                                v-model="ruleForm.captcha"
                            ></el-input>
                        </el-form-item>
                        <span class="erification">
                            <img :src="captchaUrl" alt="点击刷新" id="img" />
                        </span>
                        <span class="huanyi" @click="changeCaptcha()"
                            >看不清，换一张?</span
                        >
                    </el-col>
                    <el-col>
                        <el-form-item class="btn">
                            <el-button @click="resetForm('ruleForm')"
                                >重填</el-button
                            >
                            <el-button
                                :disabled="disabled"
                                @click="submitForm('ruleForm')"
                                type="primary"
                                >提交</el-button
                            >
                        </el-form-item>
                    </el-col>
                </el-form>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import { saveAdvise } from "@/api/guestBook";
import { menuqueryaddressid } from "@/api/menu";
import { getUserInfo } from "@/api/homePage";
var i = 1;
export default {
    data() {
        return {
            routerUrl: "",
            hrefs: "",
            ruleForm: {
                complainType: "",
                isShipper: "",
                waybill: "",
                name: "",
                phone: "",
                content: "",
                captcha: "",
                type: "2",
                platform: "1"
            },
            disabled: false,
            captchaUrl: "",
            rules: {
                complainType: [
                    {
                        required: true,
                        message: "请选择投诉类型",
                        trigger: "change"
                    }
                ],
                isShipper: [
                    {
                        required: true,
                        message: "请选择您是收货人还是发货人",
                        trigger: "change"
                    }
                ],
                waybill: [
                    {
                        required: true,
                        message: "请输入运单号",
                        trigger: "blur"
                    },
                    {
                        min: 12,
                        max: 12,
                        message: "运单号为12位",
                        trigger: "blur"
                    },
                    {
                        pattern: /^[0-9]+$/,
                        message: "只能输入数字"
                    }
                ],
                name: [
                    {
                        required: true,
                        message: "请输入姓名",
                        trigger: "blur"
                    },
                    {
                        min: 1,
                        max: 20,
                        message: "最多只支持输入20个字",
                        trigger: "blur"
                    }
                ],
                phone: [
                    {
                        required: true,
                        message: "请输入电话",
                        trigger: "blur"
                    },
                    {
                        min: 11,
                        max: 11,
                        message: "手机号码11位",
                        trigger: "blur"
                    },
                    {
                        pattern: /^1(3|4|5|7|8)\d{9}$/,
                        message: "只能输入手机号"
                    }
                ],
                content: [
                    {
                        required: true,
                        message: "请输入投诉内容",
                        trigger: "blur"
                    },
                    {
                        min: 1,
                        max: 300,
                        message: "最多只支持输入300个字",
                        trigger: "blur"
                    }
                ],
                captcha: [
                    {
                        required: true,
                        message: "请输入验证码",
                        trigger: "blur"
                    }
                ]
            }
        };
    },
    // watch: {
    //     $route(to, from) {
    //         this.wosLogin();
    //         this.changeCaptcha();
    //     }
    // },
    watch: {
        $route: {
            handler(val, oldval) {
                this.wosLogin();
                this.changeCaptcha();
            },
            // 深度观察监听
            immediate: true
        }
    },
    created() {},
    mounted() {
        // setTimeout(() => {
        //     this.changeCaptcha();
        // }, 500);
    },
    methods: {
        wosLogin() {
            return new Promise(async resolve => {
                await menuqueryaddressid({
                    name: "统一登录域名",
                    sign: "1"
                }).then(res => {
                    if (res.status == 2000) {
                        this.routerUrl = res.data.routAddress;
                    }
                    resolve();
                });
                let MenuQueryDto = { name: "用户接口", sign: "1" };
                this.hrefs = window.location.href;
                await menuqueryaddressid(MenuQueryDto).then(res => {
                    if (res) {
                        // debugger;
                        let self = this;
                        this.changeCaptcha();
                        getUserInfo(res.data.routAddress)
                            .then(res => {
                                if (res.indexOf("<!DOCTYPE html>") > -1) {
                                    sessionStorage.removeItem("wosloginFile");
                                    let islogin = sessionStorage.getItem(
                                        "userInfoView"
                                    );
                                    let wosloginFile = sessionStorage.getItem(
                                        "wosloginFile"
                                    );
                                    this.changeCaptcha();
                                    if (
                                        islogin == null &&
                                        wosloginFile == null
                                    ) {
                                        window.open(
                                            this.routerUrl +
                                                "?service=" +
                                                this.hrefs,
                                            "_self"
                                        );
                                        return;
                                    }
                                } else {
                                    sessionStorage.setItem(
                                        "wosloginFile",
                                        true
                                    );
                                    // alert("写入错误信息2");
                                    let islogin = sessionStorage.getItem(
                                        "userInfoView"
                                    );
                                    let wosloginFile = sessionStorage.getItem(
                                        "wosloginFile"
                                    );
                                    this.changeCaptcha();
                                    if (
                                        islogin == null &&
                                        wosloginFile == null
                                    ) {
                                        window.open(
                                            this.routerUrl +
                                                "?service=" +
                                                this.hrefs,
                                            "_self"
                                        );
                                        return;
                                    }
                                }
                                // sessionStorage.removeItem("wosloginFile");
                                // let islogin = sessionStorage.getItem(
                                //     "userInfoView"
                                // );
                                // let wosloginFile = sessionStorage.getItem(
                                //     "wosloginFile"
                                // );
                                // if (islogin == null && wosloginFile == null) {
                                //     window.open(
                                //         this.routerUrl +
                                //             "?service=" +
                                //             this.hrefs,
                                //         "_self"
                                //     );
                                //     return;
                                // }
                                this.changeCaptcha();
                            })
                            .catch(error => {
                                sessionStorage.setItem("wosloginFile", true);
                                // alert("写入错误信息2");
                                let islogin = sessionStorage.getItem(
                                    "userInfoView"
                                );
                                let wosloginFile = sessionStorage.getItem(
                                    "wosloginFile"
                                );
                                this.changeCaptcha();
                                if (islogin == null && wosloginFile == null) {
                                    window.open(
                                        this.routerUrl +
                                            "?service=" +
                                            this.hrefs,
                                        "_self"
                                    );
                                    return;
                                }
                            });
                        this.changeCaptcha();
                    }
                });
            });
        },
        submitForm(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.disabled = true;
                    setTimeout(() => {
                        this.disabled = false;
                    }, 500);
                    saveAdvise(this.ruleForm)
                        .then(res => {
                            if (res.status === 2000) {
                                if(res.data.status==2000){
                                    this.$message({
                                        message: res.data.message,
                                        duration: "2000",
                                        type: "success"
                                    });
                                    this.resetForm(formName);
                                    this.changeCaptcha(); 
                                }else if (res.data.status === 3001) {
                                    this.$message({
                                        message: res.data.message,
                                        type: "warning"
                                    });
                                    this.changeCaptcha();
                                }else {
                                    this.$message({
                                        message: res.data.message,
                                        type: "warning"
                                    });
                                    this.changeCaptcha();
                                }
                            }else if (res.status === 4102) {
                                this.$message({
                                    message: res.data,
                                    type: "warning"
                                });
                                this.changeCaptcha();
                            }else {
                                this.$message({
                                    message: res.message,
                                    type: "warning"
                                });
                                this.changeCaptcha();
                            }
                        })
                        .catch(err => {
                            this.$message({
                                message: "保存失败！",
                                duration: "2000",
                                type: "warning"
                            });
                        });
                } else {
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        changeCaptcha() {
            this.captchaUrl = this.GLOBAL + "nologinsystem/captcha?" + i++;
        }
    }
};
</script>
<style lang="scss" scoped>
.proposal {
    position: relative;
    .el-form {
        width: 860px;
        margin-top: 60px;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
        .long {
            width: 672px;
        }
        .code {
            width: 198px;
        }
        .tele {
            width: 363px;
        }
        .btn {
            position: relative;
            left: 50%;
            transform: translateX(-50%);
            margin-top: 30px;
            margin-bottom: 60px;
        }
        .erification {
            display: inline-block;
            width: 160px;
            height: 38px;
            border: 1px solid #ccc;
            img {
                width: 160px;
                height: 38px;
            }
        }
        .huanyi {
            cursor: pointer;
            position: relative;
            bottom: 12px;
            left: 20px;
        }
    }
}
</style>
